import { X } from "lucide-react";
import React from "react";

interface UpdateOrderDialogProps {
  setIsUpdateDialogOpen: (open: boolean) => void;
}

const UpdateOrderDialog: React.FC<UpdateOrderDialogProps> = ({
  setIsUpdateDialogOpen,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div
        className="relative bg-[#fff] rounded-[12px] shadow-lg animate-contentShow"
        style={{ width: "460px" }}
      >
        <button
          onClick={() => setIsUpdateDialogOpen(false)}
          className="absolute top-4 right-4 text-[#666] hover:text-black"
        >
          <X size={20} />
        </button>
        {/* Header */}
        <div className="p-6 border-b border-[#E5E7EB]">
          <h2 className="text-lg font-semibold text-[#111827]">Update order</h2>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-6">
          {/* Edit Rate */}
          <div>
            <label className="block text-sm font-medium text-[#111827] mb-2">
              Edit rate
            </label>
            <div className="flex items-center border border-[#D1D5DB] rounded-lg overflow-hidden">
              <span className="bg-[#F9FAFB] text-[#374151] text-sm px-3 py-2 border-r border-[#D1D5DB]">
                INR
              </span>
              <input
                type="number"
                defaultValue="99.54"
                className="flex-1 px-3 py-2 text-sm text-[#111827] outline-none border-none"
              />
            </div>
          </div>

          {/* Edit FCY Amount */}
          <div>
            <label className="block text-sm font-medium text-[#111827] mb-2">
              Edit FCY Amount
            </label>
            <div className="flex items-center border border-[#D1D5DB] rounded-lg overflow-hidden">
              <span className="bg-[#F9FAFB] text-[#374151] text-sm px-3 py-2 border-r border-[#D1D5DB]">
                USD
              </span>
              <input
                type="number"
                defaultValue="1000"
                className="flex-1 px-3 py-2 text-sm text-[#111827] outline-none border-none"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 bg-[#F9FAFB] px-6 py-4 rounded-b-[12px]">
          <button
            onClick={() => setIsUpdateDialogOpen(false)}
            className="px-5 py-2 rounded-[8px] border border-[#165FE3] text-[#165FE3] text-sm font-medium hover:bg-[#EAF1FD]"
          >
            Close
          </button>
          <button
            onClick={() => setIsUpdateDialogOpen(false)}
            className="px-5 py-2 rounded-[8px] bg-[#165FE3] text-[#fff] text-sm font-medium hover:bg-[#134fc2]"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateOrderDialog;
